import { produce } from 'immer';
import get from 'lodash/get';
import { append, assoc } from 'ramda';

const menuTreeToMap = (tree, results, path) => {
  if (Array.isArray(tree)) {
    const keys = Object.keys(tree);
    const newResults = keys.reduce((acc, key) => {
      const item = tree[key];
      // url from urlList
      if (typeof item === 'string') {
        return assoc(item, path, acc);
      }
      // item from urlList
      if (get(item, 'url')) {
        return produce(acc, (draft) => {
          draft[get(item, 'url')] = append(
            get(item, ['msg', 'title']) || get(item, ['msg', 'pageTitle']),
            path,
          );
        });
      }
      const accWithUrlList = get(item, 'urlList')
        ? menuTreeToMap(
            get(item, 'urlList'),
            acc,
            append(get(item, 'label'), path),
          )
        : acc;
      const accWithChildren = get(item, 'children')
        ? menuTreeToMap(
            get(item, 'children'),
            accWithUrlList,
            append(get(item, 'label'), path),
          )
        : accWithUrlList;
      return accWithChildren;
    }, results);
    return newResults;
  }
  return results;
};

export default menuTreeToMap;
